import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ButtonComponent } from '../../buttons/button/button.component';
import { DialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ButtonType } from '../../enum/button-type.enum';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';

@Component({
  selector: 'lib-image-cropper-dialog',
  imports: [ButtonComponent, DialogHeaderComponent, ImageCropperComponent],
  templateUrl: './image-cropper-dialog.component.html',
  styleUrl: './image-cropper-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageCropperDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ImageCropperDialogComponent>);
  protected readonly ButtonType = ButtonType;

  public readonly imageFiles = signal<File[]>([]);
  private readonly croppedImageFiles = signal<File[]>([]);
  protected currentlyCroppingImageIndex = signal(0);

  primaryButtonClicked() {
    if (this.currentlyCroppingImageIndex() === this.imageFiles().length - 1) {
      this.dialogRef.close(this.croppedImageFiles());
    } else {
      this.currentlyCroppingImageIndex.update(index => index + 1);
    }
  }

  secondaryButtonClicked() {
    this.dialogRef.close(null);
  }

  closeClicked() {
    this.dialogRef.close(null);
  }

  protected imageCropped(event: ImageCroppedEvent) {
    const imageFiles = this.imageFiles();
    const blob = event.blob;
    const index = this.currentlyCroppingImageIndex();
    this.croppedImageFiles.update(files => {
      if (blob && imageFiles) {
        files[index] = new File([blob], imageFiles[index].name, {
          type: imageFiles[index].type,
          lastModified: Date.now(),
        });
      }
      return files;
    });
  }
}
